import React, { useEffect, useRef, useState } from "react"
import showpasswordlogo from "../../../assets/images/lystfacelogos/showpassword.svg";
import hidpasswordlogo from "../../../assets/images/lystfacelogos/hidepassword.svg";
import DropDownImage from '../../../assets/images/lystfacelogos/DropDown.svg';

import infologo from "../../../assets/images/lystfacelogos/info.svg"
import { createSelector } from "reselect"
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import {
  registerUser,
  registerUserReset,
  fetchCountry,
  resetRegisterResponseMsg,
  apiError,
} from "../../../store/actions"
import PropTypes from "prop-types"

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
} from "reactstrap"
import Select from "react-select"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import country_code from "../../../constants/country_code"
import form_input_patterns from "../../../constants/form_input_patterns"

//Import Breadcrumb
import Breadcrumbs from "../../Common/Breadcrumb"
import form_messages from "../../../constants/form_messages"
import withRouter from "../../Common/withRouter"
import SmallLoader from "../../Common/SmallLoader"
import { appConstants } from "../../../constants/app_constants"
import { Countries } from "../../../helpers/lystface_helper"
import PasswordToolTip from "../../Common/PasswordToolTip"
import Toaster from "../Common/Toaster"
import toast_messages from "../../../constants/toast_messages"
import CustomSelect from "../Common/Select"
import { CustomToast, ToastContainer } from "../Common/CustomToast"
import SelectBox from "./Select";
import { devUrls, urls } from "../../../config";
import DmPhoneNumberInput from "../../Common/Inputs/phone";
import { values } from "lodash";
import { getMinMaxForPhoneCode } from "../../../common/functions";

const SignupForm = props => {
  const dispatch = useDispatch();

  const RegisterUserState = state => state.Account
  const RegisterUserProperties = createSelector(
    RegisterUserState,
    RegisterUser => ({
      loading: RegisterUser.loading,
      registrationErrorMessage: RegisterUser.registrationErrorMessage,
      registrationError: RegisterUser.registrationError,
    })
  )
  const { loading, registrationErrorMessage, registrationError } = useSelector(
    RegisterUserProperties
  )
  const [isShowPassword, setIsShowPassword] = useState({
    password: false,
    confirmPassword: false,
  })

  const [openSelectBox, setOpenSelectBox] = useState(false);
  const [planId, setPlanId] = useState('')


  const search = useLocation()?.search;

  const [isCountry, setIsCountry] = useState([])
  const [isTerms, SetIsTerms] = useState(false)




  const validationType = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      cmpEmail: "",
      cmpPhoneCode: "99",
      phone: "",
      name: "",
      // firstName: "",
      // lastName: "",
      // job_role: "",
      is_developer: true,
      cmp_name: "",
      // num_of_emp: "",
      password: "",
      confirmPassword: "",
      // cmp_address: "",
      terms: false,
    },
    validationSchema: Yup.object().shape({
      cmpEmail: Yup.string()
        .test("email", form_messages.Signup.email.Invalid, function (value) {
          let emailRegex
          if (process.env.REACT_APP_NODE !== "prod") {
            emailRegex = form_input_patterns.TESTING_EMAIL

          }
          else {
            emailRegex = form_input_patterns.EMAIL

          }
          return emailRegex.test(value)
        })
        .max(255)
        .required(form_messages.Signup.businessemail.Required),
      cmpPhoneCode: Yup.string()
        .max(10)
        .required(form_messages.Common.REQUIRED),
      phone: Yup.string()
        // .min(7, form_messages.Signup.phone.MIN7MAX15)
        // .max(15, form_messages.Signup.phone.MIN7MAX15)
        .required(form_messages.Signup.phone.Required)
        .when('cmpPhoneCode', (cmpPhoneCode, schema) => {
          const { min, max } = getMinMaxForPhoneCode(cmpPhoneCode[0]);
          return schema
            .min(min, form_messages.Signup.phone.INVALID)
            .max(max, form_messages.Signup.phone.INVALID)
        })
        .test(
          "is-not-negative",
          form_messages.Signup.phone.NONNEGATIVE,
          value => {
            const numericValue = parseFloat(value)
            return numericValue >= 0
          }
        ),
      // firstName: Yup.string()
      //   .min(1, form_messages.Signup.firstname.MIN3MAX20)
      //   .max(20, form_messages.Signup.firstname.MIN3MAX20)
      //   .trim()
      //   .required(form_messages.Signup.firstname.Required),
      // lastName: Yup.string()
      //   .min(1, form_messages.Signup.lastname.MIN3MAX20)
      //   .max(20, form_messages.Signup.lastname.MIN3MAX20)
      //   .trim()
      //   .required(form_messages.Signup.lastname.Required),
      name: Yup.string()
        .min(1, form_messages.Signup.name.MIN1CHARMAX35)
        .max(35, form_messages.Signup.name.MIN1CHARMAX35)
        .trim()
        .required(form_messages.Signup.name.Required),
      // job_role: Yup.string()
      //   .min(3, form_messages.Signup.jobrole.MIN3MAX20)
      //   .max(20, form_messages.Signup.jobrole.MIN3MAX20)
      //   .trim()
      //   .required(form_messages.Signup.jobrole.Required),
      terms: Yup.boolean().oneOf([true], form_messages.Signup.terms.AGREE),
      is_developer: Yup.boolean().required(),
      cmp_name: Yup.string()
        .min(3, form_messages.Signup.companyname.MIN3MAX100)
        .max(100, form_messages.Signup.companyname.MIN3MAX100)
        .trim()
        .required(form_messages.Signup.companyname.Required),
      // num_of_emp: Yup.number()
      //   .min(1, form_messages.Signup.employeeno.Invalid)
      //   .max(999999, form_messages.Signup.employeeno.Invalid)
      //   .required(form_messages.Signup.employeeno.Required),
      password: Yup.string()
        .matches(
          form_input_patterns.PASSWORD,
          form_messages.Signup.password.MATCH
        )
        .required(form_messages.Signup.password.Required),

      confirmPassword: Yup.string().when("password", (password, schema) => {
        return password && password.length > 0
          ? schema
            .oneOf([Yup.ref("password")], form_messages.Signup.password.SAME)
            .required(form_messages.Signup.password.ConfirmRequired)
          : schema.notRequired()
      }),

      // cmp_address: Yup.string()
      //   .min(5, form_messages.Signup.cmp_address.MIN5CHAR)
      //   .max(100, form_messages.Signup.cmp_address.MAX100CHAR)
      //   .trim()
      //   .required(form_messages.Signup.cmp_address.Required),
    }),
    onSubmit: async values => {
      const SignupData = {
        cmp_name: values.cmp_name,
        // cmp_address: values.cmp_address,
        cmp_phone_code: values.cmpPhoneCode,
        cmp_phone: values.phone,
        cmp_email: values.cmpEmail,
        // num_of_emp: values.num_of_emp,
        pwd: values.password,
        // first_name: values.firstName,
        // last_name: values.lastName,
        name: values.name,
        // job_role: values.job_role,
        is_developer: values.is_developer,
        plan_id: planId
      }

      dispatch(registerUser(SignupData, props.router.navigate))
    },
  })

  useEffect(() => {
    validationType.validateForm();
  }, [validationType.values.cmpPhoneCode]);

  useEffect(() => {

    const plan_id = new URLSearchParams(search).get("plan_id") || '';

    if (plan_id) {
      setPlanId(plan_id)
    } else {
      if (process.env.REACT_APP_NODE !== "prod") {
        window.location.assign(devUrls.lfPricing)

      }
      else {
        window.location.assign(urls.lfPricing)

      }
    }


    // dispatch(fetchCountry())
  }, [])

  const onSubmitForm = (e) => {
    e.preventDefault()
    validationType.handleSubmit()
    return false
  }

  const handlePhoneChange = (phoneDetails, name, e) => {
    validationType.setFieldValue("cmpPhoneCode", phoneDetails.cCode)
    validationType.setFieldValue("phone", phoneDetails.phNum)
  }

  const handleSetPassword = (e) => {
    setIsShowPassword(prev => {
      return {
        ...prev,
        [e.target.name]: !isShowPassword?.[e.target.name],
      }
    })
  }

  const selectedCountry = isCountry.find(z => z.cid === validationType.values.cmpPhoneCode);

  return (
    <React.Fragment>
      <div className="auth-form-container">
        <Card>
          <CardBody>
            <Form
              onSubmit={(e) => onSubmitForm(e)}
              className="custom-validation"
            >
              <div className="title">
                Signup
              </div>
              <div className="form-fields-container">
                <div className="form-input-container">
                  <label className="form-input-title">
                    Business email<span className="text-danger"> *</span>
                  </label>
                  <Input
                    name="cmpEmail"
                    className={`form-input ${validationType.touched.cmpEmail &&
                      validationType.errors.cmpEmail
                      ? `border-danger`
                      : ``
                      }`}
                    formNoValidate={true}
                    type="text"
                    onChange={validationType.handleChange}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.cmpEmail?.trimStart() || ""}
                  />
                  {validationType.touched.cmpEmail &&
                    validationType.errors.cmpEmail ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.cmpEmail}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="form-input-container">
                  <Label className="form-input-title">
                    Phone number<span className="text-danger"> *</span>
                  </Label>
                  <DmPhoneNumberInput
                    error={(validationType.touched.phone || validationType.touched.cmpPhoneCode) && (validationType.errors.phone || validationType.errors.cmpPhoneCode) ? validationType.errors.phone : ''}
                    onInputChange={handlePhoneChange}
                    onBlur={validationType.handleBlur}
                    // value={validationType.values.phone || ""}
                    className={`dm-input form-input password-input ${(validationType.touched.phone || validationType.touched.cmpPhoneCode) && (validationType.errors.phone || validationType.errors.cmpPhoneCode)
                      ? `border-danger`
                      : ``
                      }`}
                    name="phone"
                    countryCode={validationType.values.cmpPhoneCode || ""}
                    phoneNum={validationType.values.phone || ""}
                  />
                </div>


                {/* <div className="form-input-container">
                  <Label className="form-input-title">
                    First name<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    name="firstName"
                    type="text"
                    className={`form-input ${validationType.touched.firstName &&
                      validationType.errors.firstName
                      ? `border-danger`
                      : ``
                      }`}
                    onChange={validationType.handleChange}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.firstName || ""}
                  />
                  {validationType.touched.firstName &&
                    validationType.errors.firstName ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.firstName}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="form-input-container">
                  <Label className="form-input-title">
                    Last name<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    name="lastName"
                    type="text"
                    className={`form-input ${validationType.touched.lastName &&
                      validationType.errors.lastName
                      ? `border-danger`
                      : ``
                      }`}
                    onChange={validationType.handleChange}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.lastName || ""}
                  />
                  {validationType.touched.lastName &&
                    validationType.errors.lastName ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.lastName}
                    </FormFeedback>
                  ) : null}
                </div> */}
                <div className="form-input-container">
                  <Label className="form-input-title">
                    Name<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    name="name"
                    type="text"
                    className={`form-input ${validationType.touched.name &&
                      validationType.errors.name
                      ? `border-danger`
                      : ``
                      }`}
                    onChange={validationType.handleChange}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.name?.trimStart() || ""}
                  />
                  {validationType.touched.name &&
                    validationType.errors.name ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.name}
                    </FormFeedback>
                  ) : null}
                </div>
                {/* <div className="form-input-container">
                  <Label className="form-input-title">
                    Job role<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    name="job_role"
                    type="text"
                    className={`form-input ${validationType.touched.job_role &&
                      validationType.errors.job_role
                      ? `border-danger`
                      : ``
                      }`}
                    onChange={validationType.handleChange}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.job_role || ""}
                  />
                  {validationType.touched.job_role &&
                    validationType.errors.job_role ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.job_role}
                    </FormFeedback>
                  ) : null}
                </div> */}
                <div className="form-input-container">
                  <Label className="form-input-title">
                    Developer<span className="text-danger"> *</span>
                  </Label>
                  <select
                    name="is_developer"
                    id="is_developer"
                    className={`form-input form-input-select w-100  ${validationType.touched.is_developer &&
                      validationType.errors.is_developer
                      ? `border-danger`
                      : ``
                      }`}
                    onChange={validationType.handleChange}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.is_developer || ""}
                  >
                    <option value={true}>Yes</option>
                    <option value={false}>
                      No
                    </option>
                  </select>
                </div>
                <div className="form-input-container">
                  <Label className="form-input-title">
                    Company name<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    name="cmp_name"
                    type="text"
                    className={`form-input ${validationType.touched.cmp_name &&
                      validationType.errors.cmp_name
                      ? `border-danger`
                      : ``
                      }`}
                    onChange={validationType.handleChange}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.cmp_name?.trimStart() || ""}
                  />
                  {validationType.touched.cmp_name &&
                    validationType.errors.cmp_name ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.cmp_name}
                    </FormFeedback>
                  ) : null}
                </div>
                {/* <div className="form-input-container">
                  <Label className="form-input-title">
                    No. of employees <span className="text-danger"> *</span>
                  </Label>
                  <Input
                    name="num_of_emp"
                    label="num_of_emp"
                    className={`form-input ${validationType.touched.num_of_emp &&
                      validationType.errors.num_of_emp
                      ? `border-danger`
                      : ``
                      }`}
                    type="number"
                    onChange={validationType.handleChange}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.num_of_emp || ""}
                  />
                  {validationType.touched.num_of_emp &&
                    validationType.errors.num_of_emp ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.num_of_emp}
                    </FormFeedback>
                  ) : null}
                </div> */}
                <div className={`form-password-container ${validationType.touched.password && validationType.errors.password
                  ? ``
                  : `conditional-margin`
                  }`}>
                  <div className="d-flex align-items-end">
                    <Label className="me-1 form-input-title">
                      Password
                      <span className="text-danger"> *</span>
                    </Label>
                    <PasswordToolTip />
                  </div>
                  <Input
                    name="password"
                    type={isShowPassword.password ? `text` : "password"}
                    className={`form-input password-input ${validationType.touched.password && validationType.errors.password
                      ? `border-danger`
                      : ``
                      }`}
                    onChange={(e) => {
                      let inputValue = e.target.value.replace(/\s/g, ''); // Remove spaces
                      validationType.setFieldValue('password', inputValue); // Directly set the field value
                    }}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.password || ""}
                  />

                  <span onClick={(e) => handleSetPassword(e)} className="password-icon">
                    <img
                      name="password"
                      src={
                        !isShowPassword.password
                          ? hidpasswordlogo
                          : showpasswordlogo
                      }
                    />
                  </span>

                </div>
                <div className="conditional-margin">

                  {validationType.touched.password &&
                    validationType.errors.password ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.password}
                    </FormFeedback>
                  ) : null}
                </div>

                <div className={`form-password-container ${validationType.touched.confirmPassword && validationType.errors.confirmPassword
                  ? ``
                  : `conditional-margin`
                  }`}>
                  <Label className="me-1 form-input-title">
                    Confirm password<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    name="confirmPassword"
                    type={isShowPassword.confirmPassword ? `text` : "password"}
                    className={`form-input password-input ${validationType.touched.confirmPassword && validationType.errors.confirmPassword
                      ? `border-danger`
                      : ``
                      }`}
                    onChange={(e) => {
                      let inputValue = e.target.value.replace(/\s/g, ''); // Remove spaces
                      validationType.setFieldValue('confirmPassword', inputValue); // Directly set the field value
                    }} onBlur={validationType.handleBlur}
                    value={validationType.values.confirmPassword || ""}
                  />
                  <span onClick={(e) => handleSetPassword(e)} className="password-icon">
                    <img
                      name="confirmPassword"
                      src={
                        !isShowPassword.confirmPassword
                          ? hidpasswordlogo
                          : showpasswordlogo
                      }
                    />
                  </span>

                </div>
                <div className="conditional-margin">
                  {validationType.touched.confirmPassword &&
                    validationType.errors.confirmPassword ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.confirmPassword}
                    </FormFeedback>
                  ) : null}
                </div>


                {/* <div className="form-input-container">
                  <Label className="form-input-title">
                    Address<span className="text-danger"> *</span>
                  </Label>
                  <Input
                    name="cmp_address"
                    type="textarea"
                    rows="3"
                    className={`form-input ${validationType.touched.cmp_address &&
                      validationType.errors.cmp_address
                      ? `border-danger`
                      : ``
                      }`}
                    onChange={validationType.handleChange}
                    onBlur={validationType.handleBlur}
                    value={validationType.values.cmp_address || ""}
                  />
                  {validationType.touched.cmp_address &&
                    validationType.errors.cmp_address ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.cmp_address}
                    </FormFeedback>
                  ) : null}
                </div> */}


                <div className="d-flex flex-column">
                  <div
                    className="terms-condition-input">
                    <input
                      className="checkbox-icon"
                      type="checkbox"
                      name="terms"
                      id="termsCheckbox"
                      checked={validationType.values.terms}
                      // onChange={validationType.handleChange}
                      onBlur={validationType.handleBlur}
                      value={validationType.values.terms || ""}
                      invalid={
                        validationType.touched.terms &&
                          validationType.errors.terms
                          ? true
                          : false
                      }
                      onClick={() => {
                        validationType.setFieldValue("terms", !validationType.values.terms)
                      }}
                    />

                    <label
                      htmlFor="termsCheckbox"
                      className="checkbox-label"
                    > <div className="checkbox-input"></div>I agree to the
                      <a href={process.env.REACT_APP_NODE !== "prod" ? devUrls.lfTermsCnds : urls.lfTermsCnds} target="_blank">
                        &nbsp;Terms & Conditions
                      </a></label>

                  </div>
                  {validationType.touched.terms &&
                    validationType.errors.terms ? (
                    <FormFeedback type="invalid" className="d-block">
                      {validationType.errors.terms}
                    </FormFeedback>
                  ) : null}
                </div>
              </div>
              <button
                className="background-button"
                disabled={loading}
              >
                {loading ? <SmallLoader /> : "Signup"}
              </button>
            </Form>
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  )
}

export default withRouter(SignupForm)

SignupForm.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
}
